var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrightness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.000000 58.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,58.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500 c0 -47 4 -80 10 -80 6 0 10 30 10 70 l0 70 49 0 c28 0 53 5 56 10 4 6 -18 10 -59 10 l-66 0 0 -80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 570 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 570 c3 -5 37 -10 76 -10 l69 0 0 -70 c0 -40 4 -70 10 -70 6 0 10 33 10 80 l0 80 -86 0 c-54 0 -83 -4 -79 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 505 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 456 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 443 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223 430 c-69 -42 -83 -142 -28 -200 17 -18 29 -43 32 -71 9 -69 28 -99 63 -99 23 0 33 7 45 30 8 16 15 40 15 55 0 24 -3 25 -55 25 -42 0 -55 4 -55 15 0 8 -14 30 -31 49 -38 44 -47 92 -25 135 19 36 70 71 104 71 36 0 81 -28 102 -63 31 -51 24 -92 -23 -144 -31 -34 -15 -37 17 -4 77 81 17 221 -94 221 -19 0 -49 -9 -67 -20z m95 -337 c-2 -12 -12 -18 -28 -18 -16 0 -26 6 -28 18 -3 13 3 17 28 17 25 0 31 -4 28 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 385 c20 -9 38 -27 47 -47 12 -28 14 -30 15 -10 0 13 -11 34 -25 47 -13 14 -34 25 -47 25 -20 -1 -18 -3 10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 320 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 320 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 80 l0 -80 80 0 c47 0 80 4 80 10 0 6 -30 10 -70 10 l-70 0 0 70 c0 40 -4 70 -10 70 -6 0 -10 -33 -10 -80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 90 l0 -70 -69 0 c-39 0 -73 -5 -76 -10 -5 -7 21 -10 77 -8 l83 3 3 78 c2 48 -1 77 -8 77 -6 0 -10 -28 -10 -70z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightness);
export default __webpack_public_path__ + "static/media/brightness.f81af6d51763385ec1ee3350aa537e9c.svg";
export { ForwardRef as ReactComponent };